module.exports = __webpack_public_path__ + "img/漯河市-c.88649e96.png";